// add sentnce to the product single page if "gold" term exist in description
document.addEventListener('DOMContentLoaded', function () {

  // ✅ Run ONLY on product pages
  if (!document.body.classList.contains('template-product')) return;

  const descriptionWrapper = document.querySelector(
    '.product__section-content__block--product_description .product__section--desc .rte'
  );

  if (!descriptionWrapper) return;

  const noticeText =
    'Please note gold item prices may change due to current market fluctuations.';

  // Match whole word "gold" (case-insensitive)
  if (/\bgold\b/i.test(descriptionWrapper.innerText)) {
    if (!descriptionWrapper.querySelector('.gold-price-notice')) {
      const noticeP = document.createElement('p');
      noticeP.className = 'gold-price-notice';
      noticeP.textContent = noticeText;

      descriptionWrapper.appendChild(noticeP);
    }
  }
});
